import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import API_CONFIG from '../components/API_CONFIG/API_CONFIG';
import Logo from '../assetes/logos.png';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const login = localStorage.getItem('login');
    if (login) navigate('/Home');

    const loginStatus = localStorage.getItem('loginStatus');
    if (loginStatus) {
      setError(loginStatus);
      setTimeout(() => {
        localStorage.clear();
      }, 3000);
    }
  }, [navigate]);

  const handleInputChange = (e, type) => {
    setError('');
    if (type === 'email') setEmail(e.target.value);
    if (type === 'password') setPassword(e.target.value);
  };

  const loginSubmit = (e) => {
    e.preventDefault();
    if (email.trim() && password.trim()) {
      setLoading(true);
      const url = `${API_CONFIG.apiUrl}admin/login2.php`;

      fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response && response[0]) {
            if (response[0].result === 'Invalid Email' || response[0].result === 'Invalid Password') {
              setError(response[0].result);
            } else {
              setMsg('Connexion réussie ! Redirection...');
              localStorage.setItem('userId', response[0].id);
              localStorage.setItem('login', true);
              setTimeout(() => navigate('/Home'), 2000);
            }
          } else {
            setError('Réponse inattendue du serveur.');
          }
        })
        .catch(() => setError('Erreur de connexion serveur.'))
        .finally(() => setLoading(false));
    } else {
      setError('Tous les champs sont obligatoires');
    }
  };

  return (
    <div className="signin-wrapper">
      <style>{`
        /* ============================================================
           ENHANCED DARK BLUE GLASSMORPHISM – ERP SIGN IN
           ============================================================ */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .signin-wrapper {
          width: 100%;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: radial-gradient(ellipse at 20% 30%, #0b2a4a, #061b2f 80%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          padding: 20px;
          position: relative;
          overflow: hidden;
        }

        /* ---------- Animated background particles ---------- */
        .signin-wrapper .orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.3;
          animation: orbFloat 20s ease-in-out infinite alternate;
        }
        .signin-wrapper .orb-1 {
          width: 300px;
          height: 300px;
          background: #3b82f6;
          top: -10%;
          left: -5%;
        }
        .signin-wrapper .orb-2 {
          width: 400px;
          height: 400px;
          background: #1d4ed8;
          bottom: -15%;
          right: -10%;
          animation-delay: -8s;
        }
        .signin-wrapper .orb-3 {
          width: 200px;
          height: 200px;
          background: #60a5fa;
          top: 40%;
          right: 10%;
          animation-delay: -4s;
          opacity: 0.15;
        }

        @keyframes orbFloat {
          0% { transform: translate(0, 0) scale(1); }
          100% { transform: translate(40px, -30px) scale(1.1); }
        }

        /* ---------- Main glass card ---------- */
        .login-card {
          width: 100%;
          max-width: 1000px;
          min-height: 600px;
          background: rgba(11, 20, 40, 0.6);
          backdrop-filter: blur(30px) saturate(180%);
          -webkit-backdrop-filter: blur(30px) saturate(180%);
          border-radius: 48px;
          box-shadow: 0 40px 80px rgba(0, 0, 0, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.06);
          display: flex;
          overflow: hidden;
          border: 1px solid rgba(59, 130, 246, 0.1);
          position: relative;
          z-index: 2;
        }

        /* ---------- Left panel (branding) ---------- */
        .left-panel {
          flex: 1.1;
          background: rgba(10, 25, 50, 0.4);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 30px;
          position: relative;
          border-right: 1px solid rgba(59, 130, 246, 0.06);
          text-align: center;
          color: #e0e7ff;
          overflow: hidden;
        }

        .left-panel .glow {
          position: absolute;
          border-radius: 50%;
          background: rgba(59, 130, 246, 0.04);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.02);
        }
        .left-panel .glow-1 {
          width: 250px;
          height: 250px;
          top: -20px;
          right: -40px;
        }
        .left-panel .glow-2 {
          width: 150px;
          height: 150px;
          bottom: 20px;
          left: -30px;
        }

        .brand-icon {
          position: relative;
          z-index: 2;
          margin-bottom: 16px;
          filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.4));
        }

        .brand-title {
          font-size: 26px;
          font-weight: 700;
          letter-spacing: 2px;
          background: linear-gradient(135deg, #f0f4ff, #94a3b8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 12px;
        }

        .brand-tagline {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.5);
          max-width: 240px;
          line-height: 1.6;
          letter-spacing: 0.3px;
          position: relative;
          z-index: 2;
        }

        .left-footer {
          position: absolute;
          bottom: 30px;
          font-size: 10px;
          color: rgba(255, 255, 255, 0.25);
          letter-spacing: 0.5px;
          z-index: 2;
        }

        /* ---------- Right panel (form) ---------- */
        .right-panel {
          flex: 1.4;
          padding: 50px 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background: rgba(255, 255, 255, 0.01);
          backdrop-filter: blur(4px);
          -webkit-backdrop-filter: blur(4px);
        }

        .right-panel .logo-avatar {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 24px;
        }

        .right-panel .logo-avatar img {
          width:200px;
          height: 48px;
          border-radius: 14px;
          object-fit: cover;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        }

        .right-panel .logo-avatar span {
          font-size: 16px;
          font-weight: 600;
          color: #e0e7ff;
          letter-spacing: 0.5px;
        }

        .welcome-title {
          font-size: 30px;
          font-weight: 700;
          color: #e0e7ff;
          margin-bottom: 6px;
          line-height: 1.2;
        }

        .welcome-subtitle {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.5);
          margin-bottom: 36px;
          letter-spacing: 0.3px;
        }

        .login-form {
          width: 100%;
          max-width: 360px;
          display: flex;
          flex-direction: column;
        }

        /* ---------- Input groups with icons ---------- */
        .input-group {
          position: relative;
          margin-bottom: 18px;
        }

        .input-group .input-icon {
          position: absolute;
          left: 18px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(255, 255, 255, 0.25);
          font-size: 16px;
          transition: color 0.3s;
          pointer-events: none;
        }

        .input-pill {
          width: 100%;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          border: 1px solid rgba(255, 255, 255, 0.06);
          padding: 16px 18px 16px 50px;
          border-radius: 60px;
          font-size: 14px;
          color: #e0e7ff;
          outline: none;
          transition: all 0.25s ease;
          font-family: inherit;
          letter-spacing: 0.3px;
        }

        .input-pill::placeholder {
          color: rgba(255, 255, 255, 0.3);
        }

        .input-pill:focus {
          background: rgba(255, 255, 255, 0.08);
          border-color: #3b82f6;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
        }

        .input-pill:focus + .input-icon,
        .input-group:focus-within .input-icon {
          color: #93c5fd;
        }

        /* ---------- Options row (remember + forgot) ---------- */
        .form-options {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 32px;
          font-size: 13px;
        }

        .form-options .remember {
          display: flex;
          align-items: center;
          gap: 8px;
          color: rgba(255, 255, 255, 0.5);
          cursor: pointer;
        }

        .form-options .remember input[type="checkbox"] {
          accent-color: #3b82f6;
          width: 16px;
          height: 16px;
          cursor: pointer;
        }

        .form-options .forgot {
          color: rgba(255, 255, 255, 0.4);
          text-decoration: none;
          border-bottom: 1px solid transparent;
          transition: all 0.2s;
        }

        .form-options .forgot:hover {
          color: #93c5fd;
          border-bottom-color: rgba(147, 197, 253, 0.3);
        }

        /* ---------- Login button ---------- */
        .btn-login {
          width: 100%;
          background: linear-gradient(135deg, #3b82f6, #1d4ed8);
          border: none;
          border-radius: 60px;
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          padding: 16px 0;
          cursor: pointer;
          box-shadow: 0 8px 28px rgba(59, 130, 246, 0.3);
          transition: all 0.3s ease;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .btn-login:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 40px rgba(59, 130, 246, 0.45);
          background: linear-gradient(135deg, #2563eb, #1e40af);
        }

        .btn-login:active:not(:disabled) {
          transform: scale(0.97);
        }

        .btn-login:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        /* ---------- Sign up link ---------- */
        .signup-text {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.4);
          text-align: center;
        }

        .signup-link {
          color: #93c5fd;
          font-weight: 600;
          cursor: pointer;
          transition: color 0.2s;
          border-bottom: 1px solid transparent;
        }

        .signup-link:hover {
          color: #bfdbfe;
          border-bottom-color: rgba(147, 197, 253, 0.3);
        }

        /* ---------- Alerts ---------- */
        .msg-alert {
          width: 100%;
          padding: 12px 18px;
          border-radius: 60px;
          font-size: 13px;
          text-align: center;
          margin-bottom: 18px;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.04);
        }

        .msg-error {
          background: rgba(239, 68, 68, 0.15);
          color: #fca5a5;
          border-color: rgba(239, 68, 68, 0.1);
        }

        .msg-success {
          background: rgba(59, 130, 246, 0.12);
          color: #93c5fd;
          border-color: rgba(59, 130, 246, 0.08);
        }

        /* ---------- Responsive ---------- */
        @media (max-width: 880px) {
          .login-card {
            flex-direction: column;
            max-width: 480px;
            min-height: auto;
            border-radius: 32px;
          }

          .left-panel {
            padding: 40px 20px 30px;
            border-right: none;
            border-bottom: 1px solid rgba(59, 130, 246, 0.06);
          }

          .left-footer {
            position: relative;
            bottom: auto;
            margin-top: 16px;
          }

          .right-panel {
            padding: 40px 30px;
          }

          .right-panel .logo-avatar {
            margin-bottom: 16px;
          }
        }

        @media (max-width: 480px) {
          .right-panel {
            padding: 30px 20px;
          }
          .welcome-title {
            font-size: 24px;
          }
          .input-pill {
            padding: 14px 16px 14px 44px;
            font-size: 13px;
          }
          .btn-login {
            padding: 14px 0;
            font-size: 13px;
          }
          .form-options {
            flex-direction: column;
            gap: 12px;
            align-items: flex-start;
          }
        }
      `}</style>

      {/* Animated background orbs */}
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>
      <div className="orb orb-3"></div>

      <div className="login-card">
        {/* Left Panel – Branding */}
        <div className="left-panel">
          <div className="glow glow-1"></div>
          <div className="glow glow-2"></div>
          <div className="brand-icon">
            <svg width="64" height="64" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M35 25C35 22.2386 37.2386 20 40 20H60C73.8071 20 85 31.1929 85 45C85 52.8803 81.3533 59.9079 75.6022 64.5C81.3533 69.0921 85 76.1197 85 84C85 97.8071 73.8071 109 60 109H40C37.2386 109 35 106.761 35 104V74L20 64.5L35 55V25ZM55 40H45V60H55C60.5228 60 65 55.5228 65 50C65 44.4772 60.5228 40 55 40ZM45 69V89H60C65.5228 89 70 84.5228 70 79C70 73.4772 65.5228 69 60 69H45Z" fill="white"/>
            </svg>
          </div>
          <div className="brand-title">ERP APP</div>
          <div className="brand-tagline">
            Gérez vos ressources efficacement avec notre solution tout‑en‑un.
          </div>
          <div className="left-footer">© 2026 ERP Solutions</div>
        </div>

        {/* Right Panel – Form */}
        <div className="right-panel">
          <div className="logo-avatar">
            <img src={Logo} alt="Logo" />
            <span>ERP Platform</span>
          </div>

          <h2 className="welcome-title">Bienvenue</h2>
          <p className="welcome-subtitle text-center">Connectez‑vous pour accéder à votre tableau de bord</p>

          <form className="login-form" onSubmit={loginSubmit}>
            {error && <div className="msg-alert msg-error">{error}</div>}
            {msg && <div className="msg-alert msg-success">{msg}</div>}

            <div className="input-group">
              <input
                type="email"
                placeholder="Adresse email"
                className="input-pill"
                value={email}
                onChange={(e) => handleInputChange(e, 'email')}
                required
                aria-label="Email"
              />
              <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
            </div>

            <div className="input-group">
              <input
                type="password"
                placeholder="Mot de passe"
                className="input-pill"
                value={password}
                onChange={(e) => handleInputChange(e, 'password')}
                required
                aria-label="Password"
              />
              <FontAwesomeIcon icon={faLock} className="input-icon" />
            </div>

           

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? <FontAwesomeIcon icon={faCircleNotch} spin /> : 'Se connecter'}
            </button>

           
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignIn;